import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatFrequency'
})
export class FormatFrequencyPipe implements PipeTransform {

  transform(value: string, band: string): string {

    if (typeof value === 'undefined') {
      return value;
    }

    if (typeof band === 'undefined') {
      return value;
    }

    if (band === 'FM') {
      return value;
    }

    if (band === 'AM') {
      if (value.endsWith('.0')) {
        return value.substring(0, value.lastIndexOf('.0'));
      } else {
        return value;
      }
    }

    return value;
  }

}
